export default __webpack_public_path__ + "static/media/pec.1ea9be85.jpg";